import { isNil } from 'rambda';

/**
 * Converts boolean value to select initial value, used for Select with Yes/No options.
 * When using this kind of select with isSemiRequired, you should use this function for initial value.
 * @param value Boolean value to convert.
 * @returns Select initial value.
 */
export const booleanToSelectValue = (value: string | number | boolean | null | undefined): number | null => {
  // This is needed because isSemiRequired -> (isValueDefined == false) will reset value to null,
  // but Select with Yes/No options will parse it back to No, which is not what we want.
  if (isNil(value)) {
    return null;
  }

  return value ? 1 : 0;
};
